<template>
  <div class="form-signin">
    <div class="align-self-center">
      <b-card style="max-width: 22rem" class="mb-2">
        <b-card-text>
          <div class="mb-3 text-center">
            <img
              :src="this.$store.state.layout.logo"
              alt="iAMc"
              width="auto"
              height="35"
            />
          </div>

          <div v-if="this.$route.name === 'login'">
            <b-form @submit.stop.prevent>
              <b-form-group id="login_form" description="">
                <b-form-input
                  v-model="email"
                  type="email"
                  required
                  placeholder="Enter email"
                ></b-form-input>
                <div class="col-12" v-if="errors.email != ''">
                  <small class="text-danger" v-text="errors.email"></small>
                </div>
              </b-form-group>

              <b-form-group id="password" description="">
                <b-form-input
                  v-model="password"
                  type="password"
                  required
                  placeholder="Enter password"
                ></b-form-input>
                <div class="col-12" v-if="errors.password != ''">
                  <small class="text-danger" v-text="errors.password"></small>
                </div>
              </b-form-group>
            </b-form>

            <div v-if="processing == 0" class="text-center">
              <b-button block href="#" variant="primary" @click="doLogin">
                <i class="fas fa-sign-in-alt"></i> App Login
              </b-button>
            </div>
            <div v-else class="text-center gold">
              <i class="fas fa-atom fa-spin fa-2x"></i>
            </div>
            <div class="row small">
              <div class="col">
                <b-link
                  @click="showRegister()"
                  class="gold"
                  v-text="'Register'"
                ></b-link>
              </div>
              <div class="col text-right">
                <b-link
                  @click="showForgot()"
                  class="gold"
                  v-text="'Forgot Password?'"
                ></b-link>
              </div>
            </div>
          </div>

          <div v-else-if="this.$route.name === 'login_forgot'">
            <b-form @submit.stop.prevent>
              <b-form-group id="login_form" description="">
                <b-form-input
                  v-model="email"
                  type="email"
                  required
                  placeholder="Enter login email"
                ></b-form-input>
                <div class="col-12" v-if="errors.email != ''">
                  <small class="text-danger" v-text="errors.email"></small>
                </div>
                <div class="col-12" v-if="errors.password_reset != ''">
                  <small :class="errors.password_class" v-text="errors.password_reset"></small>
                </div>
              </b-form-group>

              <div v-if="processing == 0" class="text-center">
                <b-button
                  block
                  href="#"
                  variant="primary"
                  :disabled="disabled"
                  @click="sendPassword"
                >
                  <i class="fas fa-share"></i> Password Reset
                </b-button>
              </div>
              <div v-else class="text-center gold">
                <i class="fas fa-atom fa-spin fa-2x"></i>
              </div>
            </b-form>

            <div class="row small">
              <div class="col">
                <b-link
                  @click="showRegister()"
                  class="gold"
                  v-text="'Register'"
                ></b-link>
              </div>
              <div class="col text-right">
                <b-link
                  @click="showLogin()"
                  class="gold"
                  v-text="'Login'"
                ></b-link>
              </div>
            </div>
          </div>
        </b-card-text>
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as Cookie from "@/assets/js/cookie.js";

export default {
  name: "Login",
  props: {},
  data() {
    return {
      errors: {
        email: "",
        email_forgot: "",
        password: "",
        password_class: "",
        login: "",
        login_class: "text-danger",
        process: "",
      },
      email: null,
      password: null,
      disabled: false,
      processing: 0,
    };
  },
  methods: {
    formatter(value) {
      return value.toLowerCase();
    },
    checkInputs(type) {
      let valid = 0;
      this.errors.email = "";
      this.errors.password = "";
      this.errors.login = "";

      if (type == "forgot") {
        if (this.email === "" || this.email === null) {
          this.errors.email = "Enter an email";
        } else if (!this.validEmail(this.email)) {
          this.errors.email = "Enter a valid email";
        } else {
          valid = 1;
        }
      } else {
        if (this.email === "" || this.email === null) {
          this.errors.email = "Enter an email";
        } else if (!this.validEmail(this.email)) {
          this.errors.email = "Enter a valid email";
        } else if (this.password == "" || this.password === null) {
          this.errors.password = "Enter a password";
        } else {
          valid = 1;
        }
      }

      return valid;
    },
    getMenu(session_id) {
      let _this = this;
      axios({
        url: _this.$store.state.api_url + "userMenuGet",
        params: {
          session_id: session_id,
        },
      })
        .then(function(response) {
          if (response.data.menu.status == 1) {
            _this.$store.commit("menuSet", response.data);
          }
        })
        .catch(function() {
          console.log("Error: getMenu.");
        });
    },
    doLogin() {
      console.log("login");
      let _this = this;
      if (this.checkInputs("login") == 0) return false;

      _this.processing = 1;
      _this.errors.login_class = "gold";
      _this.errors.login = "Contacting the Server";

      let params = new URLSearchParams();
      params.append("email", this.email);
      params.append("password", this.password);

      axios({
        url: _this.$store.state.api_url + "loginProcess",
        params: params,
      })
        .then(function(response) {
          if (response.data.status == 1) {
            _this.errors.login = "Logging you In...";
            _this.$store.commit("profileSet", response.data);

            console.log(
              "_this.$store.state.app_domain:" + _this.$store.state.app_domain
            );

            console.log("set_cooke: " + response.data.profile.session_id); // TODO remove

            Cookie.setCookie(
              "user_session",
              response.data.profile.session_id,
              _this.$store.state.app_domain,
              "30"
            );

            /*if(_this.$cookies.get("user_session") == response.data.profile.session_id){*/
            console.log(Cookie.getCookie("user_session")); // TODO remove
            console.log(response.data.profile.session_id); // TODO remove
            if (
              Cookie.getCookie("user_session") ==
              response.data.profile.session_id
            ) {
              _this.getMenu(response.data.profile.session_id);
              _this.$router.push("dashboard");
            } else {
              _this.errors.login = "Session data Error...";
              Cookie.deleteCookie(
                "user_session",
                _this.$store.state.app_domain
              );
              /*_this.$cookies.remove("user_session");*/
              _this.errors.login_class = "text-danger";
              _this.processing = 0;
            }
          } else {
            _this.errors.login = response.data.message;
            Cookie.deleteCookie("user_session", _this.$store.state.app_domain);
            /*_this.$cookies.remove("user_session");*/
            _this.errors.login_class = "text-danger";
            _this.processing = 0;
          }
        })
        .catch(function() {
          _this.processing = 0;
          console.log("doLogin: error");
        });
    },
    sendPassword() {
      let _this = this;
      if (this.checkInputs("forgot") == 0) return false;

      _this.processing = 1;
      _this.errors.password_class = "gold";

      let params = new URLSearchParams();
      params.append("email", this.email);

      axios({
        url: _this.$store.state.api_url + "forgotPassword",
        params: params,
      })
        .then(function(response) {
          if (response.data.status == 1) {
            _this.disabled = true;
            _this.errors.password_reset = response.data.message;
            _this.errors.password_class = "text-success";
            _this.processing = 0;
            _this.toggle_forgot_form(0);
            /*_this.$router.push('/');*/
          } else {
            _this.errors.password_reset = response.data.message;
            _this.errors.password_class = "text-danger";
            _this.processing = 0;
          }
        })
        .catch(function() {
          _this.processing = 0;
          console.log("doLogin: error");
        });
    },
    checkLogin() {
      const sessionId = Cookie.getCookie('user_session')
      if (! sessionId) {
        this.$store.state.show_loading = 0;
        return
      }
      axios({
        url: this.$store.state.api_url + 'userGet',
        params: {
          session_id: sessionId
        },
      })
        .then((response) => {
          this.$store.state.show_loading = 0;
          if (response.data.profile.status == 1) {
            // have to redirect the page to make
            // initializing functions of App.vue to run
            window.location.href = '/'
          }
        })
    },
    toggle_forgot_form(val) {
      this.show_forgot = val;
    },
    showForgot() {
      this.$router.push("/login/forgot");
    },
    showLogin() {
      this.$router.push("/login");
    },
    showRegister() {
      this.$router.push("/register");
    },
    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var val = re.test(email);
      return val;
    },
    validName(name) {
      var letters = /^[A-Za-z]+$/;
      var val = letters.test(name);
      return val;
    },
  },
  created() {
    this.$store.state.show_loading = 1;
    this.checkLogin()
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-signin {
  width: 100%;
  max-width: 350px;
  padding: 15px;
  margin: 0 auto;
  margin-top: 15%;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
